import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { AddIcon, RemoveIcon, UploadIcon } from 'components/icons';
import { useContacts } from 'containers/pages/contacts/hooks';
import logo from '../../assets/images/stream.png';
import {
  ContactSearch,
  BulkContactUploadModal,
  ContactExistList,
  ContactList,
} from 'containers/pages/contacts/components';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { Box, Grid,Chip} from 'components/mui';

import ContactFormUnified from 'containers/pages/contacts/components/ContactFormUnified/ContactFormUnified';

function Contacts() {
  const { state, handler } = useContacts();
  const [isBulkUploadOpen, setIsBulkUploadOpen] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const contactId = searchParams.get('contactId');

  const handleExitFocusedView = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('contactId');
    setSearchParams(newParams);
    // Clear any active filters
    handler.onCompanyFilter('');
    handler.onReset();
  };

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Header row */}
      <Grid
        container
        alignItems="stretch"
        spacing={2}
        wrap="nowrap"
        sx={{ mb: 2 }}
      >
        {/* Left: New/Edit button */}
        <Grid item>
          <Button
            variant="contained"
            startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
            onClick={handler.onForm}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              height: '100%',
            }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
              {state.isAddMode ? 'NEW CONTACT' : 'EDIT CONTACT'}
            </Box>
          </Button>
        </Grid>

        {/* Right: Import button + Search */}
        <Grid item xs container alignItems="stretch" spacing={2} wrap="nowrap">
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<UploadIcon />}
              onClick={() => setIsBulkUploadOpen(true)}
              sx={{
                alignSelf: 'stretch',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                px: 2,
                borderRadius: 1,
              }}
            >
              <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                IMPORT CONTACTS
              </Box>
            </Button>
          </Grid>

          <Grid item xs>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <ContactSearch
                searchInput={state.searchInput}
                contacts={state.contacts}
                onSearchInput={handler.onSearchInput}
                onSearch={handler.onSearch}
                onReset={handler.onReset}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* Unified Form */}
      {state.isOpenForm && (
        <ContactFormUnified
          mode={state.isAddMode ? 'create' : 'edit'}
          id={state.existingContactId}                 // used only in edit mode
          contacts={state.contacts}                    // used only in create mode (typeahead)
          companies={state.companies}
          contactTypes={state.contactTypes}
          languageTypes={state.languageTypes}
          onFetchContacts={handler.onContacts}         // refresh after save/archive
          onCloseForm={handler.onForm}                 // close after create
          onHandleEstCont={handler.onEstCont}
                   // suggestions in create mode
        />
      )}

      {state.estContacts?.length > 0 && (
        <ContactExistList
          contacts={state.estContacts}
          onGetContactId={handler.onGetExistingContactId}
          onMode={handler.onMode}
        />
      )}

      <ContactList
        companies={state.companies}
        contactTypes={state.contactTypes}
        languageTypes={state.languageTypes}
        searchedContacts={state.searchedContacts}
        selectedCompany={state.selectedCompany}         
        isCompanyFiltering={state.isCompanyFiltering}   
        onContacts={handler.onContacts}
        onCompanyChange={handler.onCompanyFilter}
        highlightContactId={contactId}
        onExitFocusedView={handleExitFocusedView}
      />

      <BulkContactUploadModal
        open={isBulkUploadOpen}
        onClose={() => setIsBulkUploadOpen(false)}
        companies={state.companies}
        onContactsRefresh={handler.onContacts}
      />

      <LoadingBackdrop open={state.isLoading} />
            {/* Footer with Chip */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Chip
                label="Powered by Stream Data Systems"
                variant="outlined"
                icon={
                  <Box
                    component="img"
                    src={logo}
                    alt="logo"
                    sx={{ width: 20, height: 20 }}
                  />
                }
              />
            </Box>
    </Box>
  );
}

export default Contacts;
